<template>
  <div
    class="m-notification"
    :class="{
      'm-notification_success': isSuccess,
      'm-notification_warning': isWarning,
      'm-notification_error': isError,
    }"
    @click.stop="handleRootClick"
  >
    <div
      v-if="closeByButton"
      class="m-notification__close"
      @click="closeNotification"
    >
      <MIcon
        :icon="iconCross"
      />
    </div>
    <div class="m-notification__status-bar" />
    <div class="m-notification__contents">
      <div class="m-notification__header">
        {{ header }}
      </div>
      <div class="m-notification__text">
        {{ text }}
      </div>
      <div
        v-if="showLink"
        class="m-notification__link"
      >
        <MLink
          :href="linkUrl"
          :icon="iconArrow"
          icon-position="after"
          target="_blank"
          @click="linkAction"
        >
          {{ linkText }}
        </MLink>
      </div>
    </div>
  </div>
</template>

<script>
  import iconCross from 'assets/icons/cross.svg';
  import iconArrow from 'assets/icons/arrow.svg';
  import MIcon from 'components/Design/MIcon';
  import MLink from 'components/Links/MLink';

  export default {
    name: 'MNotification',
    components: {MIcon, MLink},
    props: {
      type: {
        type: String,
        choices: ['success', 'warning', 'error'],
        default: 'success'
      },
      text: {
        type: String,
        default: ''
      },
      header: {
        type: String,
        default: ''
      },
      linkAction: {
        type: Function,
        default: () => null
      },
      linkUrl: {
        type: String,
        default: ''
      },
      linkText: {
        type: String,
        default: ''
      },
      closeByButton: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        iconCross,
        iconArrow
      };
    },
    computed: {
      showLink () {
        return (this.linkUrl || this.linkAction) && this.linkText;
      },
      isSuccess () {
        return this.type === 'success';
      },
      isWarning () {
        return this.type === 'warning';
      },
      isError () {
        return this.type === 'error';
      }
    },
    methods: {
      handleRootClick () {
        if (!this.closeByButton) {
          this.$emit('closeNoty');
        }
      },
      closeNotification () {
        this.$emit('closeNoty');
      }
    }
  };
</script>

<style>
  .m-notification {
    overflow: hidden;
    cursor: default;

    position: relative;
    display: inline-flex;

    align-items: stretch;

    width: 100%;

    background-color: var(--background-color);

    box-shadow: 0 2px 12px rgba(71, 71, 71, 0.1);

    border-radius: 5px;
  }

  .m-notification_success {
    --notification-color: var(--success-color);
  }

  .m-notification_warning {
    --notification-color: var(--warning-color);
  }

  .m-notification_error {
    --notification-color: var(--error-color);
  }

  .m-notification__close {
    color: var(--secondary-text-color);

    cursor: pointer;

    position: absolute;
    top: 6px;
    right: 6px;

    width: 14px;
    height: 14px;
  }

  .m-notification__close:hover {
    color: var(--text-color);
  }

  .m-notification__status-bar {
    flex-grow: 0;
    flex-shrink: 0;

    width: 4px;

    background: var(--notification-color);
  }

  .m-notification__contents {
    padding: 14px;
  }

  .m-notification__header {
    font-size: var(--subtitle-font-size);
    color: var(--notification-color);
  }

  .m-notification__text {
    font-size: var(--main-font-size);

    line-height: 18px;

    margin-top: 4px;
  }

  .m-notification__link {
    font-size: var(--main-font-size);
    margin-top: 8px;
  }

  .m-notification__link .m-link {
    line-height: var(--main-line-height);
  }

</style>
